import { useEffect, useRef, type ComponentProps } from "react";
import { WeekCalendar } from "../../features/calendar/components/WeekCalendar";
import { syncFromServer } from "../../lib/api/sync";
import { getToday } from "../../shared/types/date-helpers";

const REFRESH_INTERVAL = 15_000;

type FullscreenCalendarProps = ComponentProps<typeof WeekCalendar>;

export function FullscreenCalendar(props: FullscreenCalendarProps) {
  const lastDay = useRef(getToday());

  // Auto-refresh toutes les 15s + reload si le jour change (minuit)
  useEffect(() => {
    const interval = setInterval(() => {
      syncFromServer();
      const today = getToday();
      if (today !== lastDay.current) {
        lastDay.current = today;
        window.location.reload();
      }
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-dvh overflow-hidden bg-surface max-w-screen" data-ph-no-capture>
      <WeekCalendar {...props} />
    </div>
  );
}
